import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";
import { COLOR_BLACK } from "shared/theme/colors";
import Chip from "../Chip";

export const StyledAIGradientBox = styled(Box)<{ isNewlyGenerated?: boolean }>`
  display: flex;
  align-items: center;
  height: 24px;
  padding: 3px 8px;
  gap: 8px;
  border: 2px solid transparent;
  border-radius: 8px;
  background-image: linear-gradient(#fff, #fff),
    linear-gradient(56deg, rgba(43, 120, 255, 1), rgba(206, 92, 251, 1));
  background-origin: padding-box, border-box;
  background-clip: padding-box, border-box;
  box-sizing: border-box;
  opacity: ${({ isNewlyGenerated }) => (isNewlyGenerated ? 0 : 1)};
  transform: ${({ isNewlyGenerated }) =>
    isNewlyGenerated ? "translateY(10px)" : "none"};
  animation: ${({ isNewlyGenerated }) =>
    isNewlyGenerated
      ? "fadeInOpacity 1s ease-out 4.3s forwards, fadeInTransform 1s ease-out 4.3s forwards"
      : "none"};
`;

export const GradientText = styled(Typography)`
  background: linear-gradient(
    56deg,
    rgba(43, 120, 255, 1),
    rgba(206, 92, 251, 1)
  );
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  font-weight: 500;
  font-size: 12px;
`;

export const AnimatedTypingText = styled(Typography)<{
  isNewlyGenerated?: boolean;
}>`
  font-size: 22px;
  color: ${COLOR_BLACK};
  font-style: italic;
  text-transform: uppercase;
  font-weight: 900;
  overflow: hidden;
  white-space: nowrap;
  padding-right: 8px;
  animation: ${({ isNewlyGenerated }) =>
    isNewlyGenerated ? "typing 4s steps(40, end) 0.8s forwards" : "none"};
  width: ${({ isNewlyGenerated }) => (isNewlyGenerated ? "0" : "100%")};
  max-width: fit-content;
  visibility: ${({ isNewlyGenerated }) =>
    isNewlyGenerated ? "hidden" : "visible"};

  @keyframes typing {
    0% {
      width: 0;
      visibility: visible;
    }
    100% {
      width: 100%;
      visibility: visible;
    }
  }
`;

export const ChipWrapper = styled(Box)<{ isNewlyGenerated?: boolean }>`
  opacity: ${({ isNewlyGenerated }) => (isNewlyGenerated ? 0 : 1)};
  transform: ${({ isNewlyGenerated }) =>
    isNewlyGenerated ? "translateY(10px)" : "none"};
  animation: ${({ isNewlyGenerated }) =>
    isNewlyGenerated
      ? "fadeInOpacity 1s ease-out 3.8s forwards, fadeInTransform 1s ease-out 3.8s forwards"
      : "none"};

  @keyframes fadeInOpacity {
    to {
      opacity: 1;
    }
  }

  @keyframes fadeInTransform {
    to {
      transform: translateY(0);
    }
  }
`;

export const AnimatedChip = styled(Chip)`
  animation: fadeIn 0.6s ease-out 1s forwards;
  opacity: 0;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const AnimatedRightItem = styled(Box)<{ isNewlyGenerated?: boolean }>`
  opacity: ${({ isNewlyGenerated }) => (isNewlyGenerated ? 0 : 1)};
  transform: ${({ isNewlyGenerated }) =>
    isNewlyGenerated ? "translateY(10px)" : "none"};
  animation: ${({ isNewlyGenerated }) =>
    isNewlyGenerated
      ? "fadeInOpacity 0.5s ease-out 4.7s forwards, fadeInTransform 0.5s ease-out 4.7s forwards"
      : "none"};

  & > div {
    & > div {
      justify-content: flex-start;
    }
  }

  @keyframes fadeInOpacity {
    to {
      opacity: 1;
    }
  }

  @keyframes fadeInTransform {
    to {
      transform: translateY(0);
    }
  }
`;

export const AnimatedTimeWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: 2px;
  opacity: 0;
  transform: translateY(10px);
  animation:
    fadeInOpacity 1s ease-out 5s forwards,
    fadeInTransform 1s ease-out 5s forwards;

  @keyframes fadeInOpacity {
    to {
      opacity: 1;
    }
  }

  @keyframes fadeInTransform {
    to {
      transform: translateY(0);
    }
  }
`;
